import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AppConstants } from '../../../../app.constants';
import { Clients, MemberDetails, MemberSearchRequest } from '@interfaces';
import { formatPhone } from 'src/app/util';
import { BenefitManagementService, EligibilityService } from '@core';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-add-member-response-dialog',
  templateUrl: './add-member-response-dialog.component.html',
  styleUrls: ['./add-member-response-dialog.component.scss'],
  standalone: false,
})
export class AddMemberResponseDialogComponent implements OnInit {
  public displayGender = AppConstants.DISPLAY_GENDER;
  public phoneLabels = AppConstants.PHONE_LABELS;
  cardHolderRC: string = AppConstants.RELATIONSHIP_CODES_ALL.CARDHOLDER;
  public clientList: Clients[] = [];
  constructor(
    public dialogRef: MatDialogRef<AddMemberResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      member: MemberDetails;
      cardholderDetails: MemberDetails;
    },
    private router: Router,
    private eligibilityService: EligibilityService,
    private benefitService: BenefitManagementService
  ) {}

  ngOnInit(): void {
    this.benefitService
      .getClientsListByAccess()
      .pipe(
        take(1),
        tap((res) => {
          this.clientList = res;
        })
      )
      .subscribe();
  }

  public cancel(close = true): void {
    this.dialogRef.close(close);
  }
  
  public navigateBackToMemberSearch(): void {
    const client = this.clientList.filter((c)=> c.clientId === this.dialogData.cardholderDetails.clientId);
    this.eligibilityService.setSelectedClient3(client[0]);
    this.eligibilityService.setSelectedClient2(client[0]);
    this.eligibilityService.searchCriteriaCache = {
      client: this.dialogData.cardholderDetails.clientId,
      idType: 'Card/Alt ID',
      idValue: this.dialogData.cardholderDetails.cardId,
    };
    this.eligibilityService.selectedIndex = 0;
    const searchQuery: MemberSearchRequest = {
      clientId: this.dialogData.cardholderDetails.clientId,
    };
    (searchQuery.cardId = this.dialogData.cardholderDetails.cardId),
      (searchQuery.limit = 10),
      (searchQuery.offset = '0'),
      (searchQuery.count = 1),
      this.eligibilityService.queryString.next(
        this.eligibilityService.getSearchQuery(searchQuery)
      );
    this.cancel();
    this.router.navigateByUrl('/management/online-eligibility');
  }

  public navigateToAddDependent(): void {
    this.cancel();
    const queryParams = {
      clientId: this.dialogData.cardholderDetails.clientId,
      cardId: this.dialogData.cardholderDetails.cardId,
      patientId: this.dialogData.cardholderDetails.patientId,
      firstName: this.dialogData.cardholderDetails.firstName,
      groupNumber: this.dialogData.cardholderDetails.coverage.groupNumber,
      refreshPage: true,
      nav: window.crypto.getRandomValues(new Uint32Array(1))[0],
    };
    this.router.navigate(['/management/online-eligibility/add-new-dependent'], {
      queryParams: queryParams,
    });
  }

  formatPhoneNumber(phone: string): string {
    return formatPhone(phone);
  }
}
